import angular from 'angular'

/* @ngInject */
const valueHandler = () => {
  const self = {}

  self.isNull = (_item) => {
    return _item === undefined || _item === null
  }

  self.isNotNull = (_item) => {
    return !self.isNull(_item)
  }

  self.isEmpty = (_item) => {
    return _item === undefined || _item === null || _item === '' || angular.equals(_item, {}) || angular.equals(_item, [])
  }

  self.exists = (_item) => {
    return !self.isEmpty(_item)
  }

  self.isString = (_item) => {
    return angular.isString(_item)
  }

  self.isNumber = (_item) => {
    return angular.isNumber(_item)
  }

  self.isArray = (_item) => {
    return angular.isArray(_item)
  }

  self.isObject = (_item) => {
    return angular.isObject(_item)
  }

  self.isId = (_item) => {
    return (self.isNumber(_item) && _item >= 0) || (self.isString(_item) && _item.match('^[0-9]*$'))
  }

  return self
}
export default valueHandler



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/utils/valueHandler.js